export default "__VITE_ASSET__B140yR0n__"